import React from "react";
import {
  TeamOutlined,
  CalendarOutlined,
  GiftOutlined,
  ShopOutlined,
} from "@ant-design/icons";

import DashboardHeader from '../components/dashboard/DashboardHeader';
import StatisticCard from '../components/dashboard/StatisticCard';
import RecentActivities from '../components/dashboard/RecentActivities';
import UpcomingEvents from '../components/dashboard/UpcomingEvents';
import RewardProgram from '../components/dashboard/RewardProgram';
import TopProviders from '../components/dashboard/TopProviders';

const Dashboard = () => {
  const stats = [
    {
      title: "Organisateurs",
      value: "45",
      icon: <TeamOutlined />,
      color: "primary",
      growth: "+12% ce mois",
      previousValue: "40"
    },
    {
      title: "Événements actifs",
      value: "28",
      icon: <CalendarOutlined />,
      color: "success",
      growth: "+5% cette semaine",
      previousValue: "26"
    },
    {
      title: "Sponsors",
      value: "64",
      icon: <GiftOutlined />,
      color: "warning",
      growth: "+8% ce mois",
      previousValue: "59"
    },
    {
      title: "Prestataires",
      value: "92",
      icon: <ShopOutlined />,
      color: "error",
      growth: "+15% ce mois",
      previousValue: "80"
    },
  ];

  return (
    <div className="flex flex-col w-full animate-fade-in">
      <DashboardHeader />

      {/* Statistiques principales */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {stats.map((stat, index) => (
          <StatisticCard key={index} stat={stat} />
        ))}
      </div>

      {/* Section graphiques et activités */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <RewardProgram />
        <RecentActivities />
      </div>

      {/* Section événements à venir */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <TopProviders />
        <UpcomingEvents />
      </div>
    </div>
  );
};

export default Dashboard;
